module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xpelv2-01af3a701b70885b85edb18a97afa09a.jpg";